




































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Speakers extends Vue {
  constructor() {
    super();
  }

  private goToCompetition() {
    this.$router.push("/competicao");
  }
}
